export const CHECKOUT_URL = 'https://rutinasimple.com//cart/53032623636761:1'
export const OFFER_ANCHOR = '#oferta'
export const META_PIXEL_ID = '2243850073137099'
export const CHECKOUT_VARIANT_ID = '53032623636761'
export const PRODUCT_NAME = 'Protocolo Lujo de Farmacia'
